setInterval(()=>{
    $(".call__btn").addClass("_icon2")
    setTimeout(()=>{
        $(".call__btn").removeClass("_icon2")
    },1600)
},4800)


setTimeout(()=>{
    setInterval(()=>{
        $(".call__btn").addClass("_icon3")
        setTimeout(()=>{
            $(".call__btn").removeClass("_icon3")
        },1600)
    },4800)
},1600)
